import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <Link to='/'>
      <HeaderDiv className='absolute z-50 top-3 right-7 hover:cursor-pointer text-base font-extrabold text-white'>
        <span className='active:text-blue-300'>{`</ JP > `}</span>
      </HeaderDiv>
    </Link>
  );
}

export default Header;

const HeaderDiv = styled.div`
  transition: 0.3s all ease-out;
  :hover {
    transform: scale(1.1);
  }
  :hover::after {
    content: '.Dev';
  }
`;
